<template>

    <div class="d-flex align-items-center justify-content-between mb-3">
        <div>
            {{ __(':from - :to von :total Ergebnissen', {from: $options.filters.localizeNumber(meta.from || 0), to: $options.filters.localizeNumber(meta.to || 0), total: $options.filters.localizeNumber(meta.total)}) }}
        </div>
    </div>

</template>


<script>
    export default {
        props: [
            'meta',
        ],
        data() {
            return {
            }
        },
        methods: {
        },
        watch: {
        },
    }
</script>